export function ToNumber(): PropertyDecorator {
  return (target: object, propertyKey: string | symbol) => {
    let value: unknown;

    const getter = () => {
      return value;
    };

    const setter = (newValue: unknown) => {
      value = Number(newValue);
    };

    if (delete target[propertyKey]) {
      Object.defineProperty(target, propertyKey, {
        get: getter,
        set: setter,
        enumerable: true,
        configurable: true,
      });
    }
  };
}
